export default __webpack_public_path__ + "static/media/menu-master.ea63b961.svg";